// /utils/reports/proval/samFixedInterval.js

/**
 * SAM Fixed Interval Export
 * Source: segments (excluding exceptions)
 * Output: Start, Stop, Left IRI, Right IRI, MRI
 */

function sanitizeFilename(str) {
  return str.replace(/[^a-zA-Z0-9-_]/g, '_').substring(0, 50);
}

export function generateSAMFixedInterval(segments, options = {}) {
  const { format = 'txt' } = options;
  const delimiter = format === 'csv' ? ',' : '\t';
  
  // Sort all segments to find true session start
  const allSorted = [...segments].sort((a, b) => a.from_station_ft - b.from_station_ft);
  const sessionStart = allSorted[0]?.from_station_ft ?? 0;
  
  // Filter to non-exception segments only, then sort
  const validSegments = allSorted.filter(seg => !seg.exception);
  
  const headers = [
    'Start Distance (ft)',
    'Stop Distance (ft)',
    'Left IRI (in/mi)',
    'Right IRI (in/mi)',
    'MRI (in/mi)'
  ];
  
  const lines = [headers.join(delimiter)];
  
  validSegments.forEach(seg => {
    const row = [
      (seg.from_station_ft - sessionStart).toFixed(1),
      (seg.to_station_ft - sessionStart).toFixed(1),
      seg.iri_left_in_per_mi?.toFixed(2) ?? '',
      seg.iri_right_in_per_mi?.toFixed(2) ?? '',
      seg.iri_avg_in_per_mi?.toFixed(2) ?? ''
    ];
    lines.push(row.join(delimiter));
  });
  
  return lines.join('\n');
}

export function getSAMFixedIntervalFilename(session, format = 'txt') {
  const name = sanitizeFilename(session?.name || 'Session');
  return `SAM_Fixed_Interval_${name}.${format}`;
}